import { PlannerBase }   from "../planner_base";
import { Global } from './model';
import moment from 'moment';
import {
  PLANNER_CLICK_BACK_SCHEDULE,
  PLANNER_CLICK_FORWARD_SCHEDULE
} from 'apps/events';
class LineBackForward extends PlannerBase {
  clickEvent: string;
  isShow: boolean = false;
  tooltipValue: string;
  init(){
    super.init();
    let schedules = this.getMySchedules();
    if(schedules == null){ return; }
    this.showIfNecessary(schedules);
  }
  getMySchedules(){
    let lineData = Global.getLineData(this.opts.dataLineId);
    if(!lineData){ return null; }
    if(lineData.schedules.length <= 0){ return null; }
    return lineData.schedules;
  }
  onClick(){
    let schedules = this.getMySchedules();
    let startTime = this.getStartDate(schedules);
    let customEvent = new CustomEvent(this.clickEvent, {detail: startTime});
    document.dispatchEvent(customEvent);
  }
  getStartDate(schedules: Array<string>): any{ return moment(); } //override this event
  protected showIfNecessary(schedules: Array<string>){
    if(this.isItNecessary(schedules)){
      this.show();
    }
  }
  protected isItNecessary(schedules: Array<string>):boolean{ // override
    return false;
  }
  protected show(){
    this.isShow = true;
    this.update();
  }
  getGlobalDate(){ return moment(); } // override
  getDiff(schedules: Array<string>): number{
    let firstDate = this.getStartDate(schedules);
    this.tooltipValue = this.opts.locale.tooltip + firstDate.format('YYYY-MM-DD');
    let globalDate = this.getGlobalDate();
    let diff = globalDate.diff(firstDate);
    return diff;
  }
}
class LineBack extends LineBackForward {
  clickEvent = PLANNER_CLICK_BACK_SCHEDULE
  getStartDate(schedules): any{
    return moment(Global.getScheduleData(schedules[0]).start_time);
  }
  protected isItNecessary(schedules: Array<string>):boolean{
    let diff = this.getDiff(schedules);
    return diff > 0;
  }
  getGlobalDate(){
    let start = Global.getPlannerData().start;
    return moment(start)
  }
}
class LineForward extends LineBackForward {
  clickEvent = PLANNER_CLICK_FORWARD_SCHEDULE
  getStartDate(schedules): any{
    return moment(Global.getScheduleData(schedules[schedules.length - 1]).start_time);
  }
  protected isItNecessary(schedules: Array<string>):boolean{
    let diff = this.getDiff(schedules);
    return diff < 0;
  }
  getGlobalDate(){
    let start = Global.getPlannerData().start;
    return moment(start).add(90, 'day');
  }
}
riot.mixin('orders.planner.line-back', LineBack as riot.TagMixin)
riot.mixin('orders.planner.line-forward', LineForward as riot.TagMixin)
